<template>
  <header>
    <div class="content">
      <div class="header">
        <div class="header__logo">
          <div>
            <img class="header__logo_image01" src="../assets/image/01.jpg" alt="台灣三菱商事物流股份有限公司" width="822" height="153" />
          </div>
          <div>
            <img class="header__logo_image02" src="../assets/image/BANNER.FOOTER-TWN.png" alt="台灣三菱商事物流股份有限公司" width="1134" height="80" />
          </div>
        </div>
        <div class="header__buttons">
          <a class="header__buttons_button lbl_btn" href="matching_service_introduction_materials.pdf" download="線上詢價服務介紹-台灣三菱商事物流.pdf" v-on:click="trackDownload">服務介紹</a>
          <a class="header__buttons_button org_btn" href="javascript:void(0);" v-on:click="scrollToFormTab()">聯絡我們</a>
        </div>
      </div>
    </div>
  </header>

  <main>
    <section class="fv">
      <div class="fv__image">
      </div>
      <div class="fv__content content">
      </div>
    </section>

    <section class="form">
      <div class="content">
        <div class="form__title__image">
          <img src="../assets/image/form_title_image1.png" alt="主視覺圖：台灣三菱商事物流股份有限公司的線上詢價服務。只需在網頁填寫即可輕鬆取得國際物流中必不可少的貨櫃海運費用報價。不需註冊會員、也不需登入操作，網頁服務全部免費。最快於提交當日即可收到報價回覆e-mail." width="4031" height="984" />
        </div>
      </div>
      <div class="form__tab content" id="form" ref="form_tab">
        <datalist id="portlist">
          <option v-for="port in ports" :key="port.id" :value="port.short_name"></option>
        </datalist>
        <!-- タブ1 -->
        <label>
          <input type="radio" name="form_tab01" value="0" v-model.number="rough_estimate.transport_fee_tab" v-on:click="tabChanged()">
          <span>海運費查詢</span>
        </label>
        <template v-if="rough_estimate.transport_fee_tab == 0">
        <div class="form__body">
          <div class="text--right mb--5">*必填項目</div>
          <form>
            <div class="form_body__content">
              <div class="form__body__form">
                <ul class="form__body__list">
                    <li v-for="(route, index) in sea_route_inquiry" :key="index">
                      <div class="form__body__list-item"> 	
                        <dl class="required">
                        <dt><label :for="'sea-POL' + index">起運港(POL)</label><span class="text--bold">*</span></dt>
                        <dd>
                          <input :name="'sea-POL' + index" :id="'sea-POL' + index" type="text" list="portlist" placeholder="可手動輸入港口名" v-model="route.pol">
                        </dd>
                        <dd class="direct-check">
                          <label :for="'sea-direct' + index" class="form__checkbox">僅限直航<input :name="'sea-direct' + index" :id="'sea-direct' + index" type="checkbox" v-model="route.direct_delivery"><i></i></label>
                        </dd>                    
                      </dl>
                      <dl class="required">
                        <dt><label :for="'sea-POD' + index">卸貨港(POD)</label><span class="text--bold">*</span></dt>
                        <dd>
                          <input :name="'sea-POD' + index" :id="'sea-POD' + index" type="text" list="portlist" placeholder="可手動輸入港口名" v-model="route.pod">
                        </dd>
                      </dl>
                    </div>
                    <dl class="required">
                      <dt><label :for="'sea-container' + index">櫃型</label><span class="text--bold">*</span></dt>
                      <dd class="ft-checkboxes">
                        <label :for="'sea-container20ft'+ index" class="form__checkbox">20ft<input :name="'sea-container20ft' + index" :id="'sea-container20ft' + index" type="checkbox" v-model="route.container_type_20ft"><i></i></label>
                        <label :for="'sea-container40ft'+ index" class="form__checkbox">40ft<input :name="'sea-container40ft' + index" :id="'sea-container40ft' + index" type="checkbox" v-model="route.container_type_40ft"><i></i></label>
                      </dd>
                      <dd class="kind-selects">
                        <span>種類</span>
                        <select :id="'sea-container' + index" :name="'sea-container' + index" v-model.number="route.container_type">
                          <option v-for="(container_type, index) in container_types" :key="index" :value="container_type.id">{{container_type.container_type}}</option>
                        </select>
                      </dd>
                    </dl>
                    <div class="form__body__list-item"> 	
                      <dl>
                        <dt><label :for="'sea-dangerous' + index">危險品</label></dt>
                        <dd class="dangerous-check">
                          <label :for="'sea-dangerous' + index" class="form__checkbox"><input :name="'sea-dangerous' + index" :id="'sea-dangerous' + index" type="checkbox" v-model="route.dangerous_goods"><i></i></label>
                        </dd>
                      </dl>
                      <dl>
                        <dt><label :for="'sea-frequency' + index">出貨櫃數/月</label></dt>
                        <dd><input :name="'sea-frequency' + index" :id="'sea-frequency' + index" type="text" maxlength="3" v-model.number="route.number_of_shipments"></dd>
                      </dl>
                    </div>
                  </li>
                </ul>
                <div class="add_row_button"><span>其他航線請按此追加</span><button type="button" v-on:click.prevent="addSeaRouteInquiry()">追加航線</button></div>
              </div>
              <div class="form__error__text">
                <p v-for="(error1,index) in errors1" :key="index">{{error1}}</p>
              </div>
              <div class="form__body__email">
                <div class="request-text">
                  <label for="sea-other_request">其他需求</label>
                  <input type="text" name="sea-other_request" id="sea-other_request" placeholder="例:FREE TIME條件,貨物包裝型態(選填)" v-model="rough_estimate.request">
                </div>
                <div class="price-text">
                  <label>預算金額</label>
                  <input type="text" name="sea-price1" id="sea-price1" placeholder="選填" v-model="rough_estimate.desired_transportation_fee">
                </div>
                <button type="button" class="sea-mail-btn" v-on:click.prevent="errCheck1()"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc. --><path d="M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm0 48v40.8c-22.4 18.3-58.2 46.7-134.6 106.5-16.8 13.2-50.2 45.1-73.4 44.7-23.2 .4-56.6-31.5-73.4-44.7C106.2 199.5 70.4 171.1 48 152.8V112h416zM48 400V214.4c22.9 18.3 55.4 43.9 104.9 82.6 21.9 17.2 60.1 55.2 103.1 55 42.7 .2 80.5-37.2 103.1-54.9 49.5-38.8 82-64.4 104.9-82.7V400H48z"/></svg>前往輸入電子郵件地址<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!-- !Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc. --><path d="M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm113.9 231L234.4 103.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L285.1 256 183.5 357.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L369.9 273c9.4-9.4 9.4-24.6 0-34z"/></svg></button>
              </div>

              <div class="form__modal" :class="{'show': dialogModal}">
                <div class="form__modal__content">
                  <div class="form__modal__content__title">
                    <h2>請填寫聯絡方式</h2>
                  </div>
                  <div class="form__modal__content__body">
                    <ul class="form__modal__list">
                      <li>
                        <div class="form__modal__name-pair">
                          <label for="sea-last-name" class="sr-only">姓</label>
                         <input
                            id="sea-last-name"
                            name="sea-last-name"
                            type="text"
                            placeholder="姓"
                            v-model="rough_estimate.last_name"
                          />
                            <label for="sea-first-name" class="sr-only">名</label>
                          <input
                            id="sea-first-name"
                            name="sea-first-name"
                            type="text"
                            placeholder="名"
                            v-model="rough_estimate.first_name"
                          />
                        </div>
                      </li>
                      <li>
                        <label for="sea-company">
                          <input id="sea-company" name="sea-company" type="text" placeholder="公司名稱" v-model="rough_estimate.company_name">
                        </label>
                      </li>
                      <li>
                        <label for="sea-email">
                          <input id="sea-email" name="sea-email" type="text" placeholder="E-mail (不可使用免費信箱)" v-model="rough_estimate.email">
                        </label>
                      </li>
                      <li>
                        <label for="sea-email2">
                          <input id="sea-email2" name="sea-email2" type="text" placeholder="E-mail (再輸入)" v-model="rough_estimate.email_conf">
                        </label>
                      </li>
                      <li>
                        <label for="sea-tel">
                          <input id="sea-tel" name="sea-tel" type="text" placeholder="電話號碼" v-model="rough_estimate.tel">
                        </label>
                      </li>
                      <li>
                        <label for="sea-shipping">
                          <input id="sea-shipping" name="sea-shipping" type="text" placeholder="貨物內容" v-model="rough_estimate.cargo_contents">
                        </label>
                      </li>
                      <li>
                        <label for="sea-purpose">
                          <select id="sea-purpose" name="sea-purpose" class="purpose_select"  :class="{'selected': rough_estimate.purpose_of_inquiry_type != -1}" v-model.number="rough_estimate.purpose_of_inquiry_type">
                            <option value="-1" disabled selected>諮詢目的</option>
                            <option v-for="(landSea_purpose, index) in landSea_purposes" :key="index" :value="landSea_purpose.id">{{landSea_purpose.landSea_purpose}}</option>
                          </select>
                        </label>
                      </li>
                      <li v-if="rough_estimate.purpose_of_inquiry_type == 3">
                        <label for="sea-purpose-text">
                          <textarea id="sea-purpose-text" name="sea-purpose-text" class="purpose_textarea" placeholder="方便的話，請告知我們您本次詢價的目的" rows="2" v-model="rough_estimate.purpose_of_inquiry_text"></textarea>
                        </label>
                      </li>
                    </ul>
                    <div class="form__modal__privacy">
                      <div class="form__modal__privacy__text">
                        同意<a href="javascript:void(0);" v-on:click="popupAgreement()">使用條款</a>
                      </div>
                      <div class="form__modal__privacy__check">
                        <input id="sea-privacy" name="sea-privacy" type="checkbox" v-model="privacy_chk"><label for="sea-privacy"></label>
                      </div>
                    </div>
                    <div class="form__error__text">
                      <p v-for="(error2,index) in errors2" :key="index">{{error2}}</p>
                    </div>
                    <div class="form__modal__button">
                      <button type="button" class="sea-submit" v-on:click.prevent="postRequest"> 確定送出<br>（FREE）</button>
                      <button type="button" class="form__modal__button__back" v-on:click.prevent="dialogModal = false">關閉</button>
                    </div>
                  </div>
                  <div class="form__modal__close" v-on:click.prevent="dialogModal = false"></div>
                </div>
              </div>

            </div>
          </form>
        </div>
        </template>
        <!-- /タブ1 -->

        <!-- タブ2 -->
        <label>
          <input type="radio" name="form_tab01" value="1"  v-model.number="rough_estimate.transport_fee_tab" v-on:click="tabChanged()">
          <span>海運費+倉庫+內陸運輸費用查詢</span>
        </label>
        <template v-if="rough_estimate.transport_fee_tab == 1">
        <div class="form__body">
          <div class="text--right mb--5">*必填項目</div>
          <form>
            <!-- 輸出入選択 -->
            <div class="tradeType">
              <label for="exportButton"><input type="radio" name="export_import" id="exportButton" value="0" v-model.number="rough_estimate.export_import_flg">出口</label>
              <label for="importButton"><input type="radio" name="export_import" id="importButton" value="1" v-model.number="rough_estimate.export_import_flg">進口</label>
            </div>
            <div class="form_body__content bg">
              <div class="form__body__form">
                <ul class="form__body__list">
                  <li v-for="(route, index) in sea_route_inquiry" :key="index">
                    <div class="form__body__list-item"> 	
                      <dl class="required">
                        <dt><label :for="'sea-POL' + index">起運港(POL)</label><span class="text--bold">*</span></dt>
                        <dd>
                          <input :name="'sea-POL' + index" :id="'sea-POL' + index" type="text" list="portlist" placeholder="可手動輸入港口名" v-model="route.pol">
                        </dd>
                        <dd class="direct-check">
                          <label :for="'sea-direct' + index" class="form__checkbox">僅限直航<input :name="'sea-direct' + index" :id="'sea-direct' + index" type="checkbox" v-model="route.direct_delivery"><i></i></label>
                        </dd>
                      </dl>
                      <dl class="required">
                        <dt><label :for="'sea-POD' + index">卸貨港(POD)</label><span class="text--bold">*</span></dt>
                        <dd>
                          <input :name="'sea-POD' + index" :id="'sea-POD' + index" type="text" list="portlist" placeholder="可手動輸入港口名" v-model="route.pod">
                        </dd>
                      </dl>
                    </div>
                    <dl class="required">
                      <dt><label :for="'sea-container' + index">櫃型</label><span class="text--bold">*</span></dt>
                      <dd class="ft-checkboxes">
                        <label :for="'sea-container20ft'+ index" class="form__checkbox">20ft<input :name="'sea-container20ft' + index" :id="'sea-container20ft' + index" type="checkbox" v-model="route.container_type_20ft"><i></i></label>
                        <label :for="'sea-container40ft'+ index" class="form__checkbox">40ft<input :name="'sea-container40ft' + index" :id="'sea-container40ft' + index" type="checkbox" v-model="route.container_type_40ft"><i></i></label>
                      </dd>
                      <dd class="kind-selects">
                        <span>種類</span>
                        <select :id="'sea-container' + index" :name="'sea-container' + index" v-model.number="route.container_type">
                          <option v-for="(container_type, index) in container_types" :key="index" :value="container_type.id">{{container_type.container_type}}</option>
                        </select>
                      </dd>
                    </dl>
                    <div class="form__body__list-item"> 	
                      <dl>
                        <dt><label :for="'sea-dangerous' + index">危險品</label></dt>
                        <dd class="dangerous-check">
                          <label :for="'sea-dangerous' + index" class="form__checkbox"><input :name="'sea-dangerous' + index" :id="'sea-dangerous' + index" type="checkbox" v-model="route.dangerous_goods"><i></i></label>
                        </dd>
                      </dl>
                      <dl>
                        <dt><label :for="'sea-frequency' + index">出貨櫃數/月</label></dt>
                        <dd><input :name="'sea-frequency' + index" :id="'sea-frequency' + index" type="text" maxlength="3" v-model.number="route.number_of_shipments"></dd>
                      </dl>
                    </div>
                  </li>
                </ul>
                <div class="add_row_button"><span>其他航線請按此追加</span><button type="button" v-on:click.prevent="addSeaRouteInquiry()">追加航線</button></div>
              </div>

              <div class="form__body__options">
                <ul>
                  <!-- 輸出選択時表示見積項目 -->
                  <template v-if="rough_estimate.export_import_flg == '0'">
                  <li class="options__lists is-export">
                    <div class="option__title">
                      <span>出口地報價</span>
                      <div class="radios">
                        <label for="JPExportEstimateRequiredTrue"><input type="radio" name="JPExportEstimateRequired" id="JPExportEstimateRequiredTrue" value="1"  v-model.number="rough_estimate.exp.e_place_flg" v-on:click="defaultExpExp()">必要</label>
                        <label for="JPExportEstimateRequiredFalse"><input type="radio" name="JPExportEstimateRequired" id="JPExportEstimateRequiredFalse" value="0" v-model.number="rough_estimate.exp.e_place_flg" v-on:click="clearExpExp()">不要</label>
                      </div>
                      <div class="checkbox">
                        <label>不確定(想諮詢)<input type="checkbox" name="JPExportEstimateConsultation" v-model.number="rough_estimate.exp.e_consultation"><i></i></label>
                      </div>
                    </div>
                    <div class="option__input">
                      <ul class="option__input__list">
                        <li>
                          <label>
                            提貨<input type="checkbox" name="JPExportEstimateOptions" v-model.number="rough_estimate.exp.e_shipping" :disabled="rough_estimate.exp.e_place_flg == 0"><i></i>
                          </label>
                        </li>
                        <li>
                          <label>
                            出口包裝<input type="checkbox" name="JPExportEstimateOptions" v-model.number="rough_estimate.exp.e_packaging" :disabled="rough_estimate.exp.e_place_flg == 0"><i></i>
                          </label>
                        </li>
                        <li>
                          <label>
                            貨櫃裝載作業<br>(裝櫃)<input type="checkbox" name="JPExportEstimateOptions" v-model.number="rough_estimate.exp.e_banning" :disabled="rough_estimate.exp.e_place_flg == 0"><i></i>
                          </label>
                        </li>
                        <li>
                          <label>
                            運送至港口的貨櫃運輸<br>(拖車)<input type="checkbox" name="JPExportEstimateOptions" v-model.number="rough_estimate.exp.e_drayage" :disabled="rough_estimate.exp.e_place_flg == 0"><i></i>
                          </label>
                        </li>
                        <li>
                          <label>
                            出口通關<input type="checkbox" name="JPExportEstimateOptions" v-model.number="rough_estimate.exp.e_customs_clearance" :disabled="rough_estimate.exp.e_place_flg == 0"><i></i>
                          </label>
                        </li>
                      </ul>
                      <div class="option__input__address input-disabled">
                        <label for="JPExportEstimateAddress">提貨地址</label>
                        <input type="text" name="JPExportEstimateAddress" id="JPExportEstimateAddress" placeholder="填寫簡要地址即可" v-model="rough_estimate.exp.e_pickup_address" :disabled="rough_estimate.exp.e_place_flg == 0 || !rough_estimate.exp.e_shipping">
                      </div>
                    </div>
                  </li>
                  </template>

                  <template v-if="rough_estimate.export_import_flg == '0'">
                  <!-- 輸出選択時表示見積項目 -->
                  <li class="options__lists is-export">
                    <div class="option__title">
                      <span>進口地報價</span>
                      <div class="radios">
                        <label for="ForeignImportEstimateRequiredTrue"><input type="radio" name="ForeignImportEstimateRequired" id="ForeignImportEstimateRequiredTrue" value="1" v-model.number="rough_estimate.exp.i_place_flg" v-on:click="defaultExpImp()">必要 </label>
                        <label for="ForeignImportEstimateRequiredFalse"><input type="radio" name="ForeignImportEstimateRequired" id="ForeignImportEstimateRequiredFalse" value="0" v-model.number="rough_estimate.exp.i_place_flg" v-on:click="clearExpImp()">不要</label>
                      </div>
                      <div class="checkbox">
                        <label>不確定(想諮詢)<input type="checkbox" name="ForeignImportEstimateConsultation" v-model.number="rough_estimate.exp.i_consultation"><i></i></label>
                      </div>
                    </div>
                    <div class="option__input">
                      <ul class="option__input__list">
                        <li>
                          <label>
                            進口通關<input type="checkbox" name="ForeignImportEstimateOptions" v-model.number="rough_estimate.exp.i_customs_clearance" :disabled="rough_estimate.exp.i_place_flg == 0"><i></i>
                          </label>
                        </li>
                        <li>
                          <label>
                            港口開始的貨櫃運送<br>(拖車)<input type="checkbox" name="ForeignImportEstimateOptions" v-model.number="rough_estimate.exp.i_drayage" :disabled="rough_estimate.exp.i_place_flg == 0"><i></i>
                          </label>
                        </li>
                        <li>
                          <label>
                            自貨櫃卸貨<br>(卸櫃)<input type="checkbox" name="ForeignImportEstimateOptions" v-model.number="rough_estimate.exp.i_devanning" :disabled="rough_estimate.exp.i_place_flg == 0"><i></i>
                          </label>
                        </li>
                        <li>
                          <label>
                            拆箱<input type="checkbox" name="ForeignImportEstimateOptions" v-model.number="rough_estimate.exp.i_unpacking" :disabled="rough_estimate.exp.i_place_flg == 0"><i></i>
                          </label>
                        </li>
                        <li>
                          <label>
                           配送<br>卸櫃後的貨物<input type="checkbox" name="ForeignImportEstimateOptions" v-model.number="rough_estimate.exp.i_delivery" :disabled="rough_estimate.exp.i_place_flg == 0"><i></i>
                          </label>
                        </li>
                      </ul>
                      <div class="option__input__address input-disabled">
                        <label for="ForeignImportEstimateAddress">收貨地址</label>
                        <input type="text" name="ForeignImportEstimateAddress" id="ForeignImportEstimateAddress" placeholder="填寫簡要地址即可" v-model="rough_estimate.exp.i_shipping_address" :disabled="rough_estimate.exp.i_place_flg == 0 || (!rough_estimate.exp.i_drayage && !rough_estimate.exp.i_delivery)">
                      </div>
                    </div>
                  </li>
                  </template>

                  <template v-if="rough_estimate.export_import_flg == '1'">
                  <!-- 輸入選択時表示見積項目 -->
                  <li class="options__lists is-import">
                    <div class="option__title">
                      <span>進口地報價</span>
                      <div class="radios">
                        <label for="JPImportEstimateRequiredTrue"><input type="radio" name="JPImportEstimateRequired"  id="JPImportEstimateRequiredTrue" value="1" v-model.number="rough_estimate.imp.i_place_flg" v-on:click="defaultImpImp()">必要</label>
                        <label for="JPImportEstimateRequiredFalse"><input type="radio" name="JPImportEstimateRequired"  id="JPImportEstimateRequiredFalse" value="0" v-model.number="rough_estimate.imp.i_place_flg" v-on:click="clearImpImp()">不要</label>
                      </div>
                      <div class="checkbox">
                        <label>不確定(想諮詢)<input type="checkbox" name="JPImportEstimateConsultation" v-model.number="rough_estimate.imp.i_consultation"><i></i></label>
                      </div>
                    </div>
                    <div class="option__input">
                      <ul class="option__input__list">
                        <li>
                          <label>
                            進口通關<input type="checkbox" name="JPImportEstimateOptions" v-model.number="rough_estimate.imp.i_customs_clearance" :disabled="rough_estimate.imp.i_place_flg == 0"><i></i>
                          </label>
                        </li>
                        <li>
                          <label>
                            港口開始的貨櫃運送<br>(拖車)<input type="checkbox" name="JPImportEstimateOptions" v-model.number="rough_estimate.imp.i_drayage" :disabled="rough_estimate.imp.i_place_flg == 0"><i></i>
                          </label>
                        </li>
                        <li>
                          <label>
                            自貨櫃卸貨<br>(卸櫃)<input type="checkbox" name="JPImportEstimateOptions" v-model.number="rough_estimate.imp.i_devanning" :disabled="rough_estimate.imp.i_place_flg == 0"><i></i>
                          </label>
                        </li>
                        <li>
                          <label>
                            拆箱<input type="checkbox" name="JPImportEstimateOptions" v-model.number="rough_estimate.imp.i_unpacking" :disabled="rough_estimate.imp.i_place_flg == 0"><i></i>
                          </label>
                        </li>
                        <li>
                          <label>
                            配送<br>卸櫃後的貨物<input type="checkbox" name="JPImportEstimateOptions" v-model.number="rough_estimate.imp.i_delivery" :disabled="rough_estimate.imp.i_place_flg == 0"><i></i>
                          </label>
                        </li>
                      </ul>
                      <div class="option__input__address input-disabled">
                        <label for="JPImportEstimateAddress">收貨地址</label>
                        <input type="text" name="JPImportEstimateAddress" id="JPImportEstimateAddress" placeholder="填寫簡要地址即可" v-model="rough_estimate.imp.i_shipping_address" :disabled="rough_estimate.imp.i_place_flg == 0 || (!rough_estimate.imp.i_drayage && !rough_estimate.imp.i_delivery)">
                      </div>
                    </div>
                  </li>
                  </template>
                  <template v-if="rough_estimate.export_import_flg == '1'">
                  <!-- 輸入選択時表示見積項目 -->
                  <li class="options__lists is-import">
                    <div class="option__title">
                      <span>出口地報價</span>
                      <div class="radios">
                        <label for="ForeignExportEstimateRequiredTrue"><input type="radio" name="ForeignExportEstimateRequired" id="ForeignExportEstimateRequiredTrue" value="1"  v-model.number="rough_estimate.imp.e_place_flg" v-on:click="defaultImpExp()">必要</label>
                        <label for="ForeignExportEstimateRequiredFalse"><input type="radio" name="ForeignExportEstimateRequired" id="ForeignExportEstimateRequiredFalse" value="0" v-model.number="rough_estimate.imp.e_place_flg" v-on:click="clearImpExp()">不要</label>
                      </div>
                      <div class="checkbox">
                        <label>不確定(想諮詢)<input type="checkbox" name="ForeignExportEstimateConsultation" v-model.number="rough_estimate.imp.e_consultation"><i></i></label>
                      </div>
                    </div>
                    <div class="option__input">
                      <ul class="option__input__list">
                        <li>
                          <label>
                            提貨<input type="checkbox" name="ForeignExportEstimateOptions" v-model.number="rough_estimate.imp.e_shipping" :disabled="rough_estimate.imp.e_place_flg == 0"><i></i>
                          </label>
                        </li>
                        <li>
                          <label>
                            出口包裝<input type="checkbox" name="ForeignExportEstimateOptions" v-model.number="rough_estimate.imp.e_packaging" :disabled="rough_estimate.imp.e_place_flg == 0"><i></i>
                          </label>
                        </li>
                        <li>
                          <label>
                            貨櫃裝載作業<br>(裝櫃)<input type="checkbox" name="ForeignExportEstimateOptions" v-model.number="rough_estimate.imp.e_banning" :disabled="rough_estimate.imp.e_place_flg == 0"><i></i>
                          </label>
                        </li>
                        <li>
                          <label>
                            運送至港口的貨櫃運輸<br>(拖車)<input type="checkbox" name="ForeignExportEstimateOptions" v-model.number="rough_estimate.imp.e_drayage" :disabled="rough_estimate.imp.e_place_flg == 0"><i></i>
                          </label>
                        </li>
                        <li>
                          <label>
                            出口通關<input type="checkbox" name="ForeignExportEstimateOptions" v-model.number="rough_estimate.imp.e_customs_clearance" :disabled="rough_estimate.imp.e_place_flg == 0"><i></i>
                          </label>
                        </li>
                      </ul>
                      <div class="option__input__address input-disabled">
                        <label for="ForeignExportEstimateAddress">提貨地址</label>
                        <input type="text" name="ForeignExportEstimateAddress" id="ForeignExportEstimateAddress" placeholder="填寫簡要地址即可" v-model="rough_estimate.imp.e_pickup_address" :disabled="rough_estimate.imp.e_place_flg == 0 || !rough_estimate.imp.e_shipping">
                      </div>
                    </div>
                  </li>
                  </template>

                  <!-- 倉庫需求 -->
                  <li class="options__lists options__lists--warehouse">
                    <div class="option__title">
                      <span>倉庫需求</span>
                      <div class="radios">
                        <label for="WarehouseRequiredTrue"><input type="radio" name="WarehouseRequired" id="WarehouseRequiredTrue" value="1" v-model.number="rough_estimate.warehouse_demand" v-on:click="defaultWareHouse()">有</label>
                        <label for="WarehouseRequiredFalse"><input type="radio" name="WarehouseRequired" id="WarehouseRequiredFalse" value="0" v-model.number="rough_estimate.warehouse_demand" v-on:click="clearWareHouse()">無</label>
                      </div>
                    </div>
                    <div class="option__input option__warehouse">
                      <ul class="option__warehouse__list">
                        <li class="option__warehouse__row option__warehouse__row--single">
                          <div class="option__warehouse__checks">
                            <label>
                              一般倉庫<input type="checkbox" name="WarehouseTypeGeneral" v-model="rough_estimate.w_general_demand" :disabled="rough_estimate.warehouse_demand != 1"><i></i>
                            </label>
                            <label>
                              保稅倉庫<input type="checkbox" name="WarehouseTypeBonded" v-model="rough_estimate.w_bonded_demand" :disabled="rough_estimate.warehouse_demand != 1"><i></i>
                            </label>
                            <label>
                              危險品倉庫<input type="checkbox" name="WarehouseTypeHazardous" v-model="rough_estimate.w_hazard_demand" :disabled="rough_estimate.warehouse_demand != 1"><i></i>
                            </label>
                          </div>
                          <span class="option__warehouse__note">（可複選）</span>
                        </li>
                        <li class="option__warehouse__row option__warehouse__row--single">
                          <span class="option__warehouse__label">倉庫希望地點</span>
                          <div class="option__warehouse__checks">
                            <label>
                              北部<input type="checkbox" name="WarehouseLocationNorth" v-model="rough_estimate.w_preferred_area_north" :disabled="rough_estimate.warehouse_demand != 1"><i></i>
                            </label>
                            <label>
                              中部<input type="checkbox" name="WarehouseLocationCentral" v-model="rough_estimate.w_preferred_area_central" :disabled="rough_estimate.warehouse_demand != 1"><i></i>
                            </label>
                            <label>
                              南部<input type="checkbox" name="WarehouseLocationSouth" v-model="rough_estimate.w_preferred_area_south" :disabled="rough_estimate.warehouse_demand != 1"><i></i>
                            </label>
                            <label>
                              指定區域<input type="checkbox" name="WarehouseLocationSpecific" v-model="rough_estimate.w_preferred_area_custom" :disabled="rough_estimate.warehouse_demand != 1" v-on:change="clearWareHouseLocationCustom()"><i></i>
                            </label>
                            <input type="text" class="option__warehouse__text" name="WarehouseLocationSpecificText" placeholder="（請填入指定區域）" v-model="rough_estimate.w_preferred_area_custom_text" :disabled="rough_estimate.warehouse_demand != 1 || !rough_estimate.w_preferred_area_custom">
                          </div>
                          <span class="option__warehouse__note">（可複選）</span>
                        </li>
                        <li class="option__warehouse__row option__warehouse__row--single">
                          <span class="option__warehouse__label">溫濕度控管</span>
                          <div class="option__warehouse__radios radios">
                            <label for="WarehouseTempRequiredTrue"><input type="radio" name="WarehouseTempRequired" id="WarehouseTempRequiredTrue" value=1 v-model.number="rough_estimate.w_temp_humi_ctrl" :disabled="rough_estimate.warehouse_demand != 1">需要</label>
                            <input type="text" class="option__warehouse__text" name="WarehouseTempDetails" placeholder="(請填入溫度與濕度)" v-model="rough_estimate.w_temp_humi_ctrl_text" :disabled="rough_estimate.warehouse_demand != 1 || rough_estimate.w_temp_humi_ctrl != 1">
                            <label for="WarehouseTempRequiredFalse"><input type="radio" name="WarehouseTempRequired" id="WarehouseTempRequiredFalse" value=0 v-model.number="rough_estimate.w_temp_humi_ctrl" :disabled="rough_estimate.warehouse_demand != 1" v-on:click="clearWareHouseTemp()">不需要</label>
                          </div>
                        </li>
                        <li class="option__warehouse__row option__warehouse__row--single">
                          <span class="option__warehouse__label option__warehouse__label--narrow">板數</span>
                          <select class="option__warehouse__text option__warehouse__text--short" name="WarehousePallets" v-model.number="rough_estimate.w_board_cnt" :disabled="rough_estimate.warehouse_demand != 1">
                            <option v-for="(board_option, index) in board_count_options" :key="index" :value="board_option.id">{{board_option.label}}</option>
                          </select>
                          <span class="option__warehouse__label option__warehouse__label--inline option__warehouse__label--area option__warehouse__label--narrow">坪數</span>
                          <select class="option__warehouse__text option__warehouse__text--short" name="WarehouseArea" v-model.number="rough_estimate.w_area_tsubo" :disabled="rough_estimate.warehouse_demand != 1">
                            <option v-for="(area_option, index) in area_tsubo_options" :key="index" :value="area_option.id">{{area_option.label}}</option>
                          </select>
                          <label class="form__checkbox option__warehouse__label option__warehouse__label--inline">
                            補充説明<input type="checkbox" name="WarehouseNote" v-model="rough_estimate.w_additional_notes" :disabled="rough_estimate.warehouse_demand != 1"><i></i>
                          </label>
                          <input type="text" class="option__warehouse__text option__warehouse__text--note" name="WarehouseNoteText" placeholder="（補充説明）" maxlength="200" v-model="rough_estimate.w_additional_notes_text" :disabled="rough_estimate.warehouse_demand != 1 || !rough_estimate.w_additional_notes">
                        </li>
                      </ul>
                    </div>
                  </li>

                  <!-- その他条件 -->
                  <li class="options__lists">
                    <div class="option__title">
                      <span>其他條件</span>
                    </div>
                    <div class="option__input">
                      <ul class="option__input__list">
                        <li>
                          <label>
                            貨物保險<input type="checkbox" name="OtherEstimateInsurance" v-model="rough_estimate.cargo_insurance"><i></i>
                          </label>
                        </li>
                        <li>
                          <label>
                            貨物包裝形態
                            <select name="OtherEstimatePacking" v-model="rough_estimate.cargo_packaging">
                              <option v-for="(cargo_packaging, index) in cargo_packagings" :key="index" :value="cargo_packaging.id">{{cargo_packaging.cargo_packaging}}</option>
                            </select>
                          </label>
                        </li>
                        <li>
                          <label>
                            重量(Kg)<br>/CNTR<input type="text" name="OtherEstimateWeight" placeholder="(半形字)" maxlength="9" v-model="rough_estimate.weight">
                          </label>
                        </li>
                        <li>
                          <label>
                            M3<br>/CNTR<input type="text" name="OtherEstimateM3" placeholder="(半形字)" maxlength="9" v-model="rough_estimate.m3">
                          </label>
                        </li>
                        <li>
                          <label>
                            出貨時間
                            <select name="OtherEstimateShipment" v-model="rough_estimate.shipping_time">
                              <option v-for="(shipping_time, index) in shipping_times" :key="index" :value="shipping_time.id">{{shipping_time.shipping_time}}</option>
                            </select>
                          </label>
                        </li>
                      </ul>
                      <ul class="option__input__list">
                        <li>
                          <label>
                            其他需求
                            <input type="text" name="OtherEstimateRequest" class="option__input-text" placeholder="例:FREE TIME條件,貨物包裝型態(選填)" v-model="rough_estimate.request">
                          </label>
                        </li>
                        <li>
                          <label>
                            預算金額
                            <input type="text" name="OtherEstimatePrice" placeholder="選填" v-model="rough_estimate.desired_transportation_fee">
                          </label>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>


              <div class="form__body__email">
                <div class="form__error__text">
                  <p v-for="(error1,index) in errors1" :key="index">{{error1}}</p>
                </div>
                <button type="button" class="landSea-mail-btn" v-on:click.prevent="errCheck1()"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc. --><path d="M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm0 48v40.8c-22.4 18.3-58.2 46.7-134.6 106.5-16.8 13.2-50.2 45.1-73.4 44.7-23.2 .4-56.6-31.5-73.4-44.7C106.2 199.5 70.4 171.1 48 152.8V112h416zM48 400V214.4c22.9 18.3 55.4 43.9 104.9 82.6 21.9 17.2 60.1 55.2 103.1 55 42.7 .2 80.5-37.2 103.1-54.9 49.5-38.8 82-64.4 104.9-82.7V400H48z"/></svg>前往輸入電子郵件地址<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!-- !Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc. --><path d="M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm113.9 231L234.4 103.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L285.1 256 183.5 357.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L369.9 273c9.4-9.4 9.4-24.6 0-34z"/></svg></button>
              </div>

              <div class="form__modal" :class="{'show': dialogModal}">
                <div class="form__modal__content">
                  <div class="form__modal__content__title">
                    <h2>請填寫聯絡方式</h2>
                  </div>
                  <div class="form__modal__content__body">
                    <ul class="form__modal__list">
                      <li>
                        <div class="form__modal__name-pair">
                          <label for="landSea-last-name" class="sr-only">姓</label>
                          <input
                            id="landSea-last-name"
                            name="landSea-last-name"
                            type="text"
                            placeholder="姓"
                            v-model="rough_estimate.last_name"
                          />
                          <label for="landSea-first-name" class="sr-only">名</label>
                          <input
                            id="landSea-first-name"
                            name="landSea-first-name"
                            type="text"
                            placeholder="名"
                            v-model="rough_estimate.first_name"
                          />
                        </div>
                      </li>
                      <li>
                        <label for="landSea-company">
                          <input id="landSea-company" name="landSea-company" type="text" placeholder="公司名稱" v-model="rough_estimate.company_name">
                        </label>
                      </li>
                      <li>
                        <label for="landSea-email">
                          <input id="landSea-email" name="landSea-email" type="text" placeholder="E-mail (不可使用免費信箱)" v-model="rough_estimate.email">
                        </label>
                      </li>
                      <li>
                        <label for="landSea-email2">
                          <input id="landSea-email2" name="landSea-email2" type="text" placeholder="E-mail (再輸入)" v-model="rough_estimate.email_conf">
                        </label>
                      </li>
                      <li>
                        <label for="landSea-tel">
                          <input id="landSea-tel" name="landSea-tel" type="text" placeholder="電話號碼" v-model="rough_estimate.tel">
                        </label>
                      </li>
                      <li>
                        <label for="landSea-shipping">
                          <input id="landSea-shipping" name="landSea-shipping" type="text" placeholder="貨物內容" v-model="rough_estimate.cargo_contents">
                        </label>
                      </li>
                      <li>
                        <label for="sea-purpose">
                          <select id="sea-purpose" name="sea-purpose" class="purpose_select" :class="{'selected': rough_estimate.purpose_of_inquiry_type != -1}" v-model.number="rough_estimate.purpose_of_inquiry_type">
                            <option value="-1" disabled selected>諮詢目的</option>
                            <option v-for="(landSea_purpose, index) in landSea_purposes" :key="index" :value="landSea_purpose.id">{{landSea_purpose.landSea_purpose}}</option>
                          </select>
                        </label>
                      </li>
                      <li v-if="rough_estimate.purpose_of_inquiry_type == 3">
                        <label for="sea-purpose-text">
                          <textarea id="sea-purpose-text" name="sea-purpose-text" class="purpose_textarea" placeholder="方便的話，請告知我們您本次詢價的目的" rows="2" v-model="rough_estimate.purpose_of_inquiry_text"></textarea>
                        </label>
                      </li>
                    </ul>
                    <div class="form__modal__privacy">
                      <div class="form__modal__privacy__text">
                        同意<a href="javascript:void(0);" v-on:click="popupAgreement()">使用條款</a>
                      </div>
                      <div class="form__modal__privacy__check">
                        <input id="landSea-privacy" name="landSea-privacy" type="checkbox" v-model="privacy_chk"><label for="landSea-privacy"></label>
                      </div>
                    </div>
                    <div class="form__error__text">
                      <p v-for="(error2,index) in errors2" :key="index">{{error2}}</p>
                    </div>
                    <div class="form__modal__button">
                      <button type="button" class="landSea-submit" v-on:click.prevent="postRequest"> 確定送出<br>（FREE）</button>
                      <button type="button" class="form__modal__button__back" v-on:click.prevent="dialogModal = false">關閉</button>
                    </div>
                  </div>
                  <div class="form__modal__close" v-on:click.prevent="dialogModal = false"></div>
                </div>
              </div>
            </div>

          </form>
        </div>
        <!-- /タブ2 -->
        </template>
      </div>
    </section>

    <section class="guide" id="flow">
      <div class="content">
        <div class="guide__title">
          <h2>服務特點</h2>
        </div>
        <div class="guide__body">
          <ul>
            <li class="guide__item">
              <div class="guide__image">
                <img src="../assets/image/guide_image01.png" alt="無需註冊會員，任何人都能輕鬆使用本服務。此服務完全免費。這是一項供任何人都可輕易使用並取得國際運費價格的線上詢價服務。本服務的優點在於能將索取Ocean Freight 或Container Freight的Web Quote過程簡便化。" width="1236" height="985" />
              </div>
            </li>
            <li class="guide__arrow">
              <i><img src="../assets/image/arrow_down-1.svg" alt="" width="100" height="100" class="arrow_down" /></i>
            </li>
            <li class="guide__item">
              <div class="guide__image">
                <img src="../assets/image/guide_image02.png" alt="本服務能提供各式各樣運送模式或與進出口相關的國內費用報價。不局限於海運費用，內陸拖車、貨車、報關、倉儲費等項目之報價皆可應對。" width="1236" height="985" />
              </div>
            </li>
            <li class="guide__arrow">
              <i><img src="../assets/image/arrow_down-1.svg" alt="" width="100" height="100" class="arrow_down" /></i>
            </li>
            <li class="guide__item">
              <div class="guide__image">
                <img src="../assets/image/guide_image03.png" alt="1分鐘內即可完成詢價資訊輸入。本服務亦可用於諮詢國際物流中的海陸運費用、報關成本的變化與比較。我們亦能辦理進出口與三角貿易的案件，並以E-mail提供參考報價。" width="1236" height="985" />
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <section class="faq" id="faq">
      <div class="content">
        <div class="faq__title">
          <h2>常見問題</h2>
        </div>
        <div class="faq__lists">
          <ul>
            <li>
              <div> 	
<span class="q">Q</span> 	
<p>任何人都可以使用此服務嗎?</p> 	
</div>
              <div> 	
<span class="a">A</span> 	
<p>是的。如果是法人，任何人都可以使用。</p> 	
</div>
            </li>
            <li>
              <div> 	
<span class="q">Q</span> 	
<p>可以使用哪些運輸方式?</p> 	
</div>
              <div> 	
<span class="a">A</span> 	
<p>可以提供海運以及其相關的卡車運輸、包裝、報關等一系列物流安排。不過，目前暫不提供空運服務。</p> 	
</div>
            </li>
            <li>
              <div> 	
<span class="q">Q</span> 	
<p>只有國內運輸也能對應嗎?</p> 	
</div>
              <div> 	
<span class="a">A</span> 	
<p>此頁面只適用國際運送。如您只有國內運輸的需求,請MAIL 至 cs.info@mclogi.com.tw與我們聯繫。</p> 	
</div>
            </li>
            <li>
              <div> 	
<span class="q">Q</span> 	
<p>是否也能對應國外的運輸和通關呢?</p> 	
</div>
              <div> 	
<span class="a">A</span> 	
<p>本公司將與國外分公司或合作夥伴公司協同，為您提供海外物流服務。</p> 	
</div>
            </li>
            <li>
              <div> 	
<span class="q">Q</span> 	
<p>無法裝入貨櫃的大型貨物也能處理嗎？</p> 	
</div>
              <div> 	
<span class="a">A</span> 	
<p>可以。請在“櫃型選擇”欄內，選擇您需要的櫃型。如果您不確定哪個櫃型最合適，請選擇“需諮詢”選項。我們將通過電子郵件等方式與您進一步確認詳細信息，並提供最佳方案給您。</p> 	
</div>
            </li>
            <li>
              <div> 	
<span class="q">Q</span> 	
<p>即使尚未確定具體的出貨時間與內容，也可以使用此服務嗎？</p> 	
</div>
              <div> 	
<span class="a">A</span> 	
<p>沒問題！即使只是想先大概了解費用，也歡迎隨時使用本服務。</p> 	
</div>
            </li>
            <li>
              <div> 	
<span class="q">Q</span> 	
<p>請問可提供哪些倉儲服務？</p> 	
</div>
              <div> 	
<span class="a">A</span> 	
<p>除入出庫儲存服務外，我們亦提供多項客製化加值服務，如撕貼標、拆併板等，並可協助安排入出庫卡車運送。如有其他額外需求，請填寫於「其他需求」欄位，我們將透過電子郵件與您聯繫。</p> 	
</div>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </main>

  <footer>
    <div class="footer__title">
      <h2>公司概要</h2>
      <p>台灣三菱商事物流是提供化學品、食品、消費品、工業品等<br>各類商品物流服務的國際物流貨物運輸承攬業者。</p>
    </div>
    <div class="footer__about">
      <ul>
        <li> 	
<span>公司名稱</span> 	
<p>台灣三菱商事物流股份有限公司</p> 	
</li>
        <li> 	
<span>公司地址</span> 	
<p>桃園市中壢區環北路398號2樓之3(凱撒雙星)</p> 	
</li>
        <li> 	
<span>資本額</span> 	
<p>新台幣2,000萬</p> 	
</li>
        <li> 	
<span>負責人</span> 	
<p>董事長兼總經理 長田洋始</p> 	
</li>
        <li> 	
<span>資本組成</span> 	
<p>Mitsubishi Corporation LT,Inc. 100%出資</p> 	
</li>
        <li> 	
<span>營業內容</span> 	
<p>國際複合運送業、海運承攬業國內運輸業、倉庫業,通關食品報驗及第三方物流,其他。</p> 	
</li>
        <li> 	
<span>公司成立</span> 	
<p>2000年4月</p> 	
</li>
      </ul>
    </div>
    <div class="footer__link">
        <div class="footer__logo">
          <img src="../assets/image/BANNER.FOOTER-TWN.png" alt="台灣三菱商事物流股份有限公司" width="1134" height="80" />
        </div>
        <div class="footer__text">320-675 桃園市中壢區環北路398號2樓之3<br>
<span>Copyright©2026, Mitsubishi Corporation LT Taiwan Co., Ltd. All Rights Reserved.</span>
</div>
    </div>
  </footer>
</template>

<script>
import axios from 'axios'
import dummy from '@/dummy'

export default {
  name: 'LandingPage',
  data: function () {
    return {
      campaigns:[
      ],

      dialogModal: false,
      rough_estimate: {
        last_name:  '',
        first_name:  '',
        company_name:  '',
        email:  '',
        email_conf: '',
        tel:   '',
        cargo_contents:  '',
        purpose_of_inquiry_type:  -1,
        purpose_of_inquiry_text:  '',

        transport_fee_tab: 0,
        export_import_flg: 0,
        exp: {
          e_place_flg: 1,
          e_consultation: false,
          e_shipping: false,
          e_packaging: true,
          e_banning: true,
          e_drayage: true,
          e_pickup_address:  '',
          e_customs_clearance: true,
          
          i_place_flg: 0,
          i_consultation: false,
          i_customs_clearance: false,
          i_drayage: false,
          i_devanning: false,
          i_unpacking: false,
          i_delivery: false,
          i_shipping_address:  '',
        },
        imp: {
          i_place_flg: 1,
          i_consultation: false,
          i_customs_clearance: true,
          i_drayage: true,
          i_devanning: false,
          i_unpacking: false,
          i_delivery: false,
          i_shipping_address:  '',

          e_place_flg: 0,
          e_consultation: false,
          e_shipping: false,
          e_packaging: false,
          e_banning: false,
          e_drayage: false,
          e_pickup_address:  '',
          e_customs_clearance: false,
        },
        cargo_insurance: 0,
        cargo_packaging: -1,
        weight: '',
        m3: '',
        shipping_time: -1,

        request:  '',
        desired_transportation_fee:  '',

        warehouse_demand: -1,
        w_general_demand: false,
        w_bonded_demand: false,
        w_hazard_demand: false,
        w_preferred_area_north: false,
        w_preferred_area_central: false,
        w_preferred_area_south: false,
        w_preferred_area_custom: false,
        w_preferred_area_custom_text: '',
        w_temp_humi_ctrl: -1,
        w_temp_humi_ctrl_text: '',
        w_board_cnt: -1,
        w_area_tsubo: -1,
        w_additional_notes: false,
        w_additional_notes_text: '',
      },   
      sea_route_inquiry: [
        {
          pol: '',
          pod: '',
          container_type_20ft: 0,
          container_type_40ft: 0,
          container_type: 0,
          dangerous_goods: 0,
          number_of_shipments: '',
          direct_delivery: 0,
        }
      ],
      privacy_chk: false,
      errors1:[],
      errors2:[],
      required_errors:[],
      format_errors:[],
      invalid_domains: [
        '@gmail.com',
        '@outlook.com',
        '@hotmail.com',
        '@icloud.com',
        '@me.com',
        '@live.com',
        '@msn.com',
        '@yahoo.com.tw',
        '@kimo.com',
        '@msa.hinet.net',
        '@pchome.com.tw',
        '@seed.net.tw',
        '@yam.com',
        '@so-net.net.tw',
        '@mailinator.com',
        '@yopmail.com',
        '@10minutemail.com',
        '@guerrillamail.com',
        '@temp-mail.org',
        '@trashmail.com',
        '@sharklasers.com',
        '@maildrop.cc',
        '@protonmail.com',
        '@mail.tm',
        '@getnada.com',
        '@moakt.com',
        '@duck.com',
        '@proton.me',
        '@anonaddy.com',
        '@qq.com',
        '@163.com',
        '@foxmail.com',
        '@edu.tw',
      ],
      ports:[],
      disp_ports: [],
      container_types: [
        {id: 0,	container_type: '乾櫃(GP)' },
        {id: 1,	container_type: '冷凍櫃(RF)' },
        {id: 2,	container_type: '開頂櫃(OT)' },
        {id: 3,	container_type: '平板櫃(FR）' },
        {id: 4,	container_type: '油槽櫃(ISO TANK)' },
        {id: 5,	container_type: '需諮詢' },
      ],
      cargo_packagings:[
        {id: -1,	cargo_packaging: '' },
        {id: 0,	cargo_packaging: '棧板' },
        {id: 1,	cargo_packaging: '散裝' },
        {id: 2,	cargo_packaging: '其他' },
      ],
      shipping_times: [
        {id: -1,	shipping_time: '' },
        {id: 0,	shipping_time: '一個月內' },
        {id: 1,	shipping_time: '三個月內' },
        {id: 2,	shipping_time: '三個月以上/尚未確定' },
      ],
      board_count_options: [
        {id: -1,	label: '' },
        {id: 0, label: '未定' },
        {id: 1, label: '1-50板' },
        {id: 2, label: '51-100板' },
        {id: 3, label: '101-500板' },
        {id: 4, label: '501-1,000板' },
        {id: 5, label: '超過1,000板' },
      ],
      area_tsubo_options: [
        {id: -1,	label: '' },
        {id: 0, label: '未定' },
        {id: 1, label: '1-100坪' },
        {id: 2, label: '101-200坪' },
        {id: 3, label: '201-300坪' },
        {id: 4, label: '301-500坪' },
        {id: 5, label: '超過500坪' },
      ],
      landSea_purposes: [
        {id: 0,	landSea_purpose: '尋找運輸業者' },
        {id: 1,	landSea_purpose: '評估新業務的運輸費用' },
        {id: 2,	landSea_purpose: '想知道運費行情' },
        {id: 3,	landSea_purpose: '其他 (自由填寫)' },
      ],
    }
  },
  created: function () {
    this.fetchPorts()

    const queryString = window.location.search.substring(1)
    const queryParameters = {}
    queryString.split("&").forEach((pair) => {
      const [key, value] = pair.split("=")
      queryParameters[key] = decodeURIComponent(value)
    })
    if(queryParameters.tab != null) {
      this.rough_estimate.transport_fee_tab = Number(queryParameters.tab) - 1
      console.log(this.rough_estimate.transport_fee_tab)
    }
  },
  methods: {
    errCheck1: function () {
      this.trackTmpRegistPre()
      this.errors1 = []
      let valid_cnt = 0
      for (let array_item of this.sea_route_inquiry) {
        if (array_item.pol.trim().length == 0 &&
          array_item.pod.trim().length == 0 &&
          array_item.container_type_20ft == 0 &&
          array_item.container_type_40ft == 0 &&
          array_item.container_type == 0 &&
          array_item.dangerous_goods == 0 &&
          array_item.number_of_shipments.toString().trim().length == 0 &&
          array_item.direct_delivery == 0) {
          continue
        } else {
          valid_cnt += 1
        }
        if (array_item.pol.trim().length == 0) {
          this.errors1.push('請輸入「裝貨港(POL)」')
        } else {
          if (this.getPortIdByName(array_item.pol) == -1) {
            this.errors1.push('「請輸入正確的「裝貨港(POL)」')
          }
        }
        if (array_item.pod.trim().length == 0) {
          this.errors1.push('請輸入「卸貨港(POD)」')
        } else {
          if (this.getPortIdByName(array_item.pod) == -1) {
            this.errors1.push('請輸入正確的「卸貨港(POD)」')
          }
        }
        if (array_item.container_type_20ft == 0 && array_item.container_type_40ft == 0) {
          this.errors1.push('請至少勾選一種櫃型')
        }
        if (array_item.container_type == -1) {
          this.errors1.push('請選擇貨櫃的種類')
        }
        if (!/^[0-9]*$/.test(array_item.number_of_shipments.toString().trim())) {
          this.errors1.push('請使用半型的整數數字填寫「出貨櫃數/月」')
        }
      }
      
      if (valid_cnt == 0) {
        this.errors1.push('航線資訊輸入未滿一筆')
      }
      if (this.rough_estimate.transport_fee_tab == 1) {
        if (this.rough_estimate.warehouse_demand == -1) {
          this.errors1.push('請勾選是否有倉庫需求')
        } else if (this.rough_estimate.warehouse_demand == 1) {
          if (!(this.rough_estimate.w_general_demand || this.rough_estimate.w_bonded_demand || this.rough_estimate.w_hazard_demand)){
            this.errors1.push('請至少勾選一個倉庫種類')
          }
          if (!(this.rough_estimate.w_preferred_area_north || this.rough_estimate.w_preferred_area_central || this.rough_estimate.w_preferred_area_south || this.rough_estimate.w_preferred_area_custom)){
            this.errors1.push('倉請至少勾選一個倉庫希望地點')
          }
          if (this.rough_estimate.w_preferred_area_custom && this.rough_estimate.w_preferred_area_custom_text.trim().length == 0){
            this.errors1.push('若勾選指定區域，請填寫相關內容')
          }
          if (this.rough_estimate.w_temp_humi_ctrl == -1) {
            this.errors1.push('請勾選溫溼度控管選項')
          } else if (this.rough_estimate.w_temp_humi_ctrl == 1 && this.rough_estimate.w_temp_humi_ctrl_text.trim().length == 0) {
            this.errors1.push('若勾選需要溫溼度控管，請填寫期望的溫度及濕度')
          }
          if (this.rough_estimate.w_board_cnt == -1) {
            this.errors1.push('板數 ：請從清單中選擇一項提交')
          }
          if (this.rough_estimate.w_area_tsubo == -1) {
            this.errors1.push('坪數 ：請從清單中選擇一項提交')
          }
          if (this.rough_estimate.w_additional_notes && this.rough_estimate.w_additional_notes_text.trim().length == 0) {
            this.errors1.push('若勾選補充說明，請填寫相關內容')
          }
        }
      }

      if ((!/^[0-9]*$/.test(this.rough_estimate.weight.toString().trim()))) {
        this.errors1.push('請使用半型的整數數字填寫「重量(Kg)/CNTR」')
      }
      if ((!/^[0-9]*$/.test(this.rough_estimate.m3.toString().trim()))) {
        this.errors1.push('請使用半型的整數數字填寫「M3/CNTR」')
      }
      if (this.errors1.length == 0) {
        this.dialogModal = true
      }
      return this.errors1.length == 0
    },
    errCheck2: function () {
      this.errors2 = []
      this.required_errors = []
      this.format_errors = []
      if (this.rough_estimate.last_name.trim().length == 0) {
        this.required_errors.push('「姓」')
      }
      if (this.rough_estimate.first_name.trim().length == 0) {
        this.required_errors.push('「名」')
      }
      if (this.rough_estimate.company_name.trim().length == 0) {
        this.required_errors.push('「公司名稱」')
      }
      let email_exist = false
      if (this.rough_estimate.email.trim().length == 0) {
        this.required_errors.push('「E-mail」')
      } else {
        if (!/^[a-zA-Z0-9_+-]+(.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/.test(this.rough_estimate.email.trim())){
          this.format_errors.push('「E-mail」')
        } else {
          let domain_str = this.rough_estimate.email.trim()
          domain_str = domain_str.substring(domain_str.indexOf('@'))
          console.log(domain_str)
          if(this.invalid_domains.includes(domain_str)) {
            this.errors2.push('不可使用免費或臨時信箱')
          }
          email_exist = true
        }
      }
      let email_conf_exist = false
      if (this.rough_estimate.email_conf.trim().length == 0) {
        this.required_errors.push('「E-mail (再輸入)」')
      } else {
        if (!/^[a-zA-Z0-9_+-]+(.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/.test(this.rough_estimate.email_conf.trim())){
          this.format_errors.push('「E-mail (再輸入)」')
        } else {
          email_conf_exist = true
        }
      }
      if (email_exist && email_conf_exist) {
        if (this.rough_estimate.email.trim() != this.rough_estimate.email_conf.trim()){
          this.errors2.push('E-mail與再輸入之E-mail不相同')
        }
      }
      if (this.rough_estimate.tel.trim().length == 0) {
        this.required_errors.push('「電話號碼」')
      } else {
        if (!/^[0-9]*$/.test(this.rough_estimate.tel.trim())){
          this.format_errors.push('「電話號碼」')
        }
      }
      if (this.rough_estimate.cargo_contents.trim().length == 0) {
        this.required_errors.push('「貨物内容」')
      }
      if (this.rough_estimate.purpose_of_inquiry_type == -1) {
        this.required_errors.push('「諮詢目的」')
      }
      if (this.rough_estimate.purpose_of_inquiry_type == 4 && this.rough_estimate.purpose_of_inquiry_text.trim().length == 0) {
        this.required_errors.push('「諮詢目的(自由填寫)」')
      }
      if (!this.privacy_chk) {
        this.errors2.push('您未同意使用條款')
      }

      if(this.format_errors.length > 0){
        this.errors2.unshift(this.format_errors.join('') + '不正確')
      }
      if(this.required_errors.length > 0){
        this.errors2.unshift('請輸入' + this.required_errors.join(''))
      }
      return this.errors2.length == 0
    },
    addSeaRouteInquiry: function () {
      this.sea_route_inquiry.push(
        {
          pol: '',
          pod: '',
          container_type_20ft: 0,
          container_type_40ft: 0,
          container_type: 0,
          dangerous_goods: 0,
          number_of_shipments: '',
          direct_delivery: 0,
        }
      )
    },
    postRequest: function () {
      this.trackTmpRegist()
      if (this.errCheck2()) {
        let post_json = {
          status: 'insert',
          disp:	'rough_estimate',
          language_code: 1,
          rough_estimate:	{
            company_name: this.rough_estimate.company_name,
            last_name: this.rough_estimate.last_name,
            first_name: this.rough_estimate.first_name,
            email: this.rough_estimate.email,
            cargo_contents: this.rough_estimate.cargo_contents,
            tel: this.rough_estimate.tel,
            transport_fee_tab: Number(this.rough_estimate.transport_fee_tab),
            request: this.rough_estimate.request,
            desired_transportation_fee: this.rough_estimate.desired_transportation_fee,
            purpose_of_inquiry_type: this.rough_estimate.purpose_of_inquiry_type,
            purpose_of_inquiry_text: this.rough_estimate.purpose_of_inquiry_text,
            sea_route_inquiry: []
          }
        }
        if(post_json.rough_estimate.transport_fee_tab == 1){
          post_json.rough_estimate.export_import_flg = Number(this.rough_estimate.export_import_flg)
          if(post_json.rough_estimate.export_import_flg == 0) {
            post_json.rough_estimate.e_consultation = Number(this.rough_estimate.exp.e_consultation)
            post_json.rough_estimate.e_place_flg = Number(this.rough_estimate.exp.e_place_flg)
            if(post_json.rough_estimate.e_place_flg == 1) {
              post_json.rough_estimate.e_shipping = Number(this.rough_estimate.exp.e_shipping)
              post_json.rough_estimate.e_packaging = Number(this.rough_estimate.exp.e_packaging)
              post_json.rough_estimate.e_banning = Number(this.rough_estimate.exp.e_banning)
              post_json.rough_estimate.e_drayage = Number(this.rough_estimate.exp.e_drayage)
              post_json.rough_estimate.e_customs_clearance = Number(this.rough_estimate.exp.e_customs_clearance)
              post_json.rough_estimate.e_pickup_address = this.rough_estimate.exp.e_pickup_address
            }
            post_json.rough_estimate.i_consultation = Number(this.rough_estimate.exp.i_consultation)
            post_json.rough_estimate.i_place_flg = Number(this.rough_estimate.exp.i_place_flg)
            if(post_json.rough_estimate.i_place_flg == 1) {
              post_json.rough_estimate.i_customs_clearance = Number(this.rough_estimate.exp.i_customs_clearance)
              post_json.rough_estimate.i_drayage = Number(this.rough_estimate.exp.i_drayage)
              post_json.rough_estimate.i_devanning = Number(this.rough_estimate.exp.i_devanning)
              post_json.rough_estimate.i_unpacking = Number(this.rough_estimate.exp.i_unpacking)
              post_json.rough_estimate.i_delivery = Number(this.rough_estimate.exp.i_delivery)
              post_json.rough_estimate.i_shipping_address = this.rough_estimate.exp.i_shipping_address
            }
          } else if (post_json.rough_estimate.export_import_flg == 1) { 
            post_json.rough_estimate.i_consultation = Number(this.rough_estimate.imp.i_consultation)
            post_json.rough_estimate.i_place_flg = Number(this.rough_estimate.imp.i_place_flg)
            if(post_json.rough_estimate.i_place_flg == 1) {
              post_json.rough_estimate.i_customs_clearance = Number(this.rough_estimate.imp.i_customs_clearance)
              post_json.rough_estimate.i_drayage = Number(this.rough_estimate.imp.i_drayage)
              post_json.rough_estimate.i_devanning = Number(this.rough_estimate.imp.i_devanning)
              post_json.rough_estimate.i_unpacking = Number(this.rough_estimate.imp.i_unpacking)
              post_json.rough_estimate.i_delivery = Number(this.rough_estimate.imp.i_delivery)
              post_json.rough_estimate.i_shipping_address = this.rough_estimate.imp.i_shipping_address
            }
            post_json.rough_estimate.e_consultation = Number(this.rough_estimate.imp.e_consultation)
            post_json.rough_estimate.e_place_flg = Number(this.rough_estimate.imp.e_place_flg)
            if(post_json.rough_estimate.e_place_flg == 1) {
              post_json.rough_estimate.e_shipping = Number(this.rough_estimate.imp.e_shipping)
              post_json.rough_estimate.e_packaging = Number(this.rough_estimate.imp.e_packaging)
              post_json.rough_estimate.e_banning = Number(this.rough_estimate.imp.e_banning)
              post_json.rough_estimate.e_drayage = Number(this.rough_estimate.imp.e_drayage)
              post_json.rough_estimate.e_customs_clearance = Number(this.rough_estimate.imp.e_customs_clearance)
              post_json.rough_estimate.e_pickup_address = this.rough_estimate.imp.e_pickup_address
            }
          }
          post_json.rough_estimate.warehouse_demand =  Number(this.rough_estimate.warehouse_demand)
          post_json.rough_estimate.w_general_demand =  Number(this.rough_estimate.w_general_demand)
          post_json.rough_estimate.w_bonded_demand = Number(this.rough_estimate.w_bonded_demand)
          post_json.rough_estimate.w_hazard_demand = Number(this.rough_estimate.w_hazard_demand)
          post_json.rough_estimate.w_preferred_area_north = Number(this.rough_estimate.w_preferred_area_north)
          post_json.rough_estimate.w_preferred_area_central = Number(this.rough_estimate.w_preferred_area_central)
          post_json.rough_estimate.w_preferred_area_south = Number(this.rough_estimate.w_preferred_area_south)
          post_json.rough_estimate.w_preferred_area_custom = Number(this.rough_estimate.w_preferred_area_custom)
          post_json.rough_estimate.w_preferred_area_custom_text =  this.rough_estimate.w_preferred_area_custom_text
          post_json.rough_estimate.w_temp_humi_ctrl = Number(this.rough_estimate.w_temp_humi_ctrl)
          post_json.rough_estimate.w_temp_humi_ctrl_text = this.rough_estimate.w_temp_humi_ctrl_text
          post_json.rough_estimate.w_board_cnt = Number(this.rough_estimate.w_board_cnt)
          post_json.rough_estimate.w_area_tsubo = Number(this.rough_estimate.w_area_tsubo)
          post_json.rough_estimate.w_additional_notes = Number(this.rough_estimate.w_additional_notes)
          post_json.rough_estimate.w_additional_notes_text = this.rough_estimate.w_additional_notes_text
          post_json.rough_estimate.cargo_insurance = Number(this.rough_estimate.cargo_insurance)
          post_json.rough_estimate.cargo_packaging = Number(this.rough_estimate.cargo_packaging)
          if(this.rough_estimate.weight.trim().length > 0) {
            post_json.rough_estimate.weight = Number(this.rough_estimate.weight)
          } else {
            post_json.rough_estimate.weight = -1
          }
          if(this.rough_estimate.m3.trim().length > 0) {
            post_json.rough_estimate.m3 = Number(this.rough_estimate.m3)
          } else {
            post_json.rough_estimate.m3 = -1
          }
          post_json.rough_estimate.shipping_time = Number(this.rough_estimate.shipping_time)
        }
        for (let array_item of this.sea_route_inquiry) {
          if (array_item.pol.trim().length == 0 &&
            array_item.pod.trim().length == 0 &&
            array_item.container_type_20ft == 0 &&
            array_item.container_type_40ft == 0 &&
            array_item.container_type == 0 &&
            array_item.dangerous_goods == 0 &&
            array_item.number_of_shipments.toString().trim().length == 0 &&
            array_item.direct_delivery == 0 ) {
            continue
          }
          let sea_route_inquiry = {
            pol_id: this.getPortIdByName(array_item.pol),
            pod_id: this.getPortIdByName(array_item.pod),
            container_type_20ft: Number(array_item.container_type_20ft),
            container_type_40ft: Number(array_item.container_type_40ft),
            container_type: Number(array_item.container_type),
            dangerous_goods: Number(array_item.dangerous_goods),
            number_of_shipments: -1,
            direct_delivery: Number(array_item.direct_delivery),
          }
          if(array_item.number_of_shipments.toString().trim().length > 0) {
            sea_route_inquiry.number_of_shipments = Number(array_item.number_of_shipments)
          }
          post_json.rough_estimate.sea_route_inquiry.push(sea_route_inquiry)
        }

        // console.log(post_json)
        axios.post(process.env.VUE_APP_API_URL_BASE + process.env.VUE_APP_API_EXEC, post_json)
          .then( (response) => {
            var res = response.data;
            if( res.status === 'done' ) {
              console.log(res)
              this.dialogModal = false
              setTimeout(() => {
                alert('資訊已發送完成，後續業務人員將會與您聯絡。')
              }, 200)
              this.clearAll()
            } else if( res.result === 'error' ) {
              console.log(res.msg)
              this.errors2.push('系統發生錯誤')
            } else {
              console.log(res)
              this.errors2.push('系統發生錯誤')
            }
          })
          .catch((error) => {
            if (process.env.VUE_APP_ENV === 'dev') {
              this.dialogModal = false
              setTimeout(() => {
                alert('資訊已發送完成，後續業務人員將會與您聯絡。')
              }, 200)
              this.clearAll()
            } else {
              console.log(error)
              this.errors2.push('系統發生錯誤')
            }
          })
        }
    },
    tabChanged: function () {
      this.errors1 = []
    },
    popupAgreement: function () {
      window.open('shipper_agreement_lp.pdf', '_blank', 'menubar=no,toolbar=no,location=no,status=no')
    },
    defaultExpExp: function() {
      this.rough_estimate.exp.e_shipping = false
      this.rough_estimate.exp.e_packaging = true
      this.rough_estimate.exp.e_banning = true
      this.rough_estimate.exp.e_drayage = true
      this.rough_estimate.exp.e_pickup_address = ''
      this.rough_estimate.exp.e_customs_clearance = true
    },
    defaultExpImp: function() {
      this.rough_estimate.exp.i_customs_clearance = true
      this.rough_estimate.exp.i_drayage = true
      this.rough_estimate.exp.i_devanning = false
      this.rough_estimate.exp.i_unpacking = false
      this.rough_estimate.exp.i_delivery = false
      this.rough_estimate.exp.i_shipping_address = ''
    },
    defaultImpImp: function() {
      this.rough_estimate.imp.i_customs_clearance = true
      this.rough_estimate.imp.i_drayage = true
      this.rough_estimate.imp.i_devanning = false
      this.rough_estimate.imp.i_unpacking = false
      this.rough_estimate.imp.i_delivery = false
      this.rough_estimate.imp.i_shipping_address = ''
    },
    defaultImpExp: function() {
      this.rough_estimate.imp.e_shipping = false
      this.rough_estimate.imp.e_packaging = true
      this.rough_estimate.imp.e_banning = true
      this.rough_estimate.imp.e_drayage = true
      this.rough_estimate.imp.e_pickup_address = ''
      this.rough_estimate.imp.e_customs_clearance = true
    },
    clearExpExp: function() {
      this.rough_estimate.exp.e_shipping = false
      this.rough_estimate.exp.e_packaging = false
      this.rough_estimate.exp.e_banning = false
      this.rough_estimate.exp.e_drayage = false
      this.rough_estimate.exp.e_pickup_address = ''
      this.rough_estimate.exp.e_customs_clearance = false
    },
    clearExpImp: function() {
      this.rough_estimate.exp.i_customs_clearance = false
      this.rough_estimate.exp.i_drayage = false
      this.rough_estimate.exp.i_devanning = false
      this.rough_estimate.exp.i_unpacking = false
      this.rough_estimate.exp.i_delivery = false
      this.rough_estimate.exp.i_shipping_address = ''
    },
    clearImpImp: function() {
      this.rough_estimate.imp.i_customs_clearance = false
      this.rough_estimate.imp.i_drayage = false
      this.rough_estimate.imp.i_devanning = false
      this.rough_estimate.imp.i_unpacking = false
      this.rough_estimate.imp.i_delivery = false
      this.rough_estimate.imp.i_shipping_address = ''
    },
    clearImpExp: function() {
      this.rough_estimate.imp.e_shipping = false
      this.rough_estimate.imp.e_packaging = false
      this.rough_estimate.imp.e_banning = false
      this.rough_estimate.imp.e_drayage = false
      this.rough_estimate.imp.e_pickup_address = ''
      this.rough_estimate.imp.e_customs_clearance = false
    },
    defaultWareHouse: function() {
        this.rough_estimate.w_general_demand =  false
        this.rough_estimate.w_bonded_demand =  false
        this.rough_estimate.w_hazard_demand =  false
        this.rough_estimate.w_preferred_area_north =  false
        this.rough_estimate.w_preferred_area_central =  false
        this.rough_estimate.w_preferred_area_south =  false
        this.rough_estimate.w_preferred_area_custom =  false
        this.rough_estimate.w_preferred_area_custom_text =  ''
        this.rough_estimate.w_temp_humi_ctrl =  1
        this.rough_estimate.w_temp_humi_ctrl_text =  ''
        this.rough_estimate.w_board_cnt =  -1
        this.rough_estimate.w_area_tsubo =  -1
        this.rough_estimate.w_additional_notes = false
        this.rough_estimate.w_additional_notes_text = ''
    },
    clearWareHouse: function() {
        this.rough_estimate.w_general_demand =  false
        this.rough_estimate.w_bonded_demand =  false
        this.rough_estimate.w_hazard_demand =  false
        this.rough_estimate.w_preferred_area_north =  false
        this.rough_estimate.w_preferred_area_central =  false
        this.rough_estimate.w_preferred_area_south =  false
        this.rough_estimate.w_preferred_area_custom =  false
        this.rough_estimate.w_preferred_area_custom_text =  ''
        this.rough_estimate.w_temp_humi_ctrl =  -1
        this.rough_estimate.w_temp_humi_ctrl_text =  ''
        this.rough_estimate.w_board_cnt =  -1
        this.rough_estimate.w_area_tsubo =  -1
        this.rough_estimate.w_additional_notes = false
        this.rough_estimate.w_additional_notes_text = ''
    },
    clearWareHouseLocationCustom: function() {
      if (!this.rough_estimate.w_preferred_area_custom) {
        this.rough_estimate.w_preferred_area_custom_text =  ''
      }
    },
    clearWareHouseTemp: function() {
      this.rough_estimate.w_temp_humi_ctrl_text =  ''
    },
    clearAll: function () {
      let save_tab = this.rough_estimate.transport_fee_tab
      this.rough_estimate =  {
        last_name:  '',
        first_name:  '',
        company_name:  '',
        email:  '',
        email_conf: '',
        tel:   '',
        cargo_contents:  '',
        purpose_of_inquiry_type:  -1,
        purpose_of_inquiry_text:  '',

        transport_fee_tab: save_tab,
        export_import_flg: 0,
        exp: {
          e_place_flg: 1,
          e_consultation: 0,
          e_shipping: 0,
          e_packaging: 0,
          e_banning: 0,
          e_drayage: 0,
          e_pickup_address:  '',
          e_customs_clearance: 0,
          
          i_place_flg: 0,
          i_consultation:  0,
          i_customs_clearance: 0,
          i_drayage: 0,
          i_devanning: 0,
          i_unpacking: 0,
          i_delivery: 0,
          i_shipping_address:  '',
        },
        imp: {
          i_place_flg: 1,
          i_consultation:  0,
          i_customs_clearance: 0,
          i_drayage: 0,
          i_devanning: 0,
          i_unpacking: 0,
          i_delivery: 0,
          i_shipping_address:  '',

          e_place_flg: 0,
          e_consultation: 0,
          e_shipping: 0,
          e_packaging: 0,
          e_banning: 0,
          e_drayage: 0,
          e_pickup_address:  '',
          e_customs_clearance: 0,
        },
        cargo_insurance: 0,
        cargo_packaging: -1,
        weight: '',
        m3: '',
        shipping_time: -1,

        request:  '',
        desired_transportation_fee:  '',

        warehouse_demand: -1,
        w_general_demand: false,
        w_bonded_demand: false,
        w_hazard_demand: false,
        w_preferred_area_north: false,
        w_preferred_area_central: false,
        w_preferred_area_south: false,
        w_preferred_area_custom: false,
        w_preferred_area_custom_text: '',
        w_temp_humi_ctrl: -1,
        w_temp_humi_ctrl_text: '',
        w_board_cnt: -1,
        w_area_tsubo: -1,
        w_additional_notes: false,
        w_additional_notes_text: '',
      }
      this.sea_route_inquiry = [
        {
          pol: '',
          pod: '',
          container_type_20ft: 0,
          container_type_40ft: 0,
          container_type: 0,
          dangerous_goods: 0,
          number_of_shipments: '',
          direct_delivery: 0,
        }
      ]
      this.privacy_chk = false
    },
    fetchPorts: function () {
      let post_json = {
        status: 'select',
        info:	'port_master',
      }
      axios.post(process.env.VUE_APP_API_URL_BASE + process.env.VUE_APP_API_EXEC, post_json)
        .then( (response) => {
          var res = response.data;
          if( res.status === 'done' ) {
            this.ports = res.port_master
//            this.ports.sort((a, b) => String(a.short_name).localeCompare(String(b.short_name)));
          } else if( res.result === 'error' ) {
            console.log(res.msg)
          } else {
            console.log(res)
          }
        })
        .catch(error => {
          console.log(error)
          if (process.env.VUE_APP_ENV === 'dev') {
            this.ports = dummy.ports
          }
        })
    },
    getPortNameById: function (id) {
      let arrayItem = this.ports.find(element => element.id === id)
      return arrayItem ? arrayItem.short_name : ''
    },
    getPortIdByName: function (name) {
      let arrayItem = this.ports.find(element => element.short_name === name)
      return arrayItem ? arrayItem.id : -1
    },
    trackDownload: function () {
      if (process.env.VUE_APP_ENV === 'production') {
        // eslint-disable-next-line no-undef
        // gtag('event', 'conversion', {
        //   send_to: 'AW-11319887392/eJoTCP3G7-YYEKCM35Uq',
        // })
      }
      // eslint-disable-next-line no-undef
      // gtag('event', 'conversion_test1', {
      //   send_to: 'TEST-0000000001',
      // })
    },
    trackTmpRegist: function () {
      if (process.env.VUE_APP_ENV === 'production') {
        // eslint-disable-next-line no-undef
        // gtag('event', 'conversion', {
        //   send_to: 'AW-11319887392/ZP2aCI2X9uYYEKCM35Uq',
        // })
      }
      // eslint-disable-next-line no-undef
      // gtag('event', 'conversion_test4', {
      //   send_to: 'TEST-0000000004',
      // })
    },
    trackTmpRegistPre: function () {
      if (process.env.VUE_APP_ENV === 'production') {
        // eslint-disable-next-line no-undef
        // gtag('event', 'conversion', {
        //   send_to: 'AW-11319887392/yS-qCNS_p-gYEKCM35Uq',
        // })
      }
      // eslint-disable-next-line no-undef
      // gtag('event', 'conversion_test5', {
      //   send_to: 'TEST-0000000005',
      // })
    },
    scrollToFormTab: function() {
      this.$refs["form_tab"].scrollIntoView({ behavior: 'smooth' });
    },
    portsQuery: function(event) {
      if(event.target.value != "") {
        this.disp_ports = this.ports.filter(ports => ports.short_name.startsWith(event.target.value))
      } else {
        this.disp_ports = []
      }
    }
  }
}
</script>

<style scoped>
@import '../assets/css/main.css';

</style>
